import { render, staticRenderFns } from "./CSChgModal.vue?vue&type=template&id=982d401a&scoped=true"
import script from "./CSChgModal.vue?vue&type=script&lang=js"
export * from "./CSChgModal.vue?vue&type=script&lang=js"
import style0 from "./CSChgModal.vue?vue&type=style&index=0&id=982d401a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982d401a",
  null
  
)

export default component.exports